export const BuildingTypes = {
  SHOW_BUILDING: "SHOW_BUILDING",
  ADD_BUILDING: "ADD_BUILDING",
  UPDATE_BUILDING: "UPDATE_BUILDING",
  DELETE_BUILDING: "DELETE_BUILDING",
  SHOW_BUILDING_FILTER: "SHOW_BUILDING_FILTER",
  SEND_BUILD_DELETE_CODE: "SEND_BUILD_DELETE_CODE",
};
